import React, { Component } from 'react';
import { CaseChartPanel } from '../../../../domain/case/CaseDomains';
import ServiceContainer from '../../../../config/ServiceContainer';
import { ServiceNames } from '../../../../constant/ServiceNames';
import { ChartEditorOptions, ChartJsDataModel, ChartResponse } from '../../../../domain/chart/ChartDomains';
import ChartService from '../../../../service/ChartService';
import { TransactionData } from '../../../../domain/stream/transaction/TransactionDomains';
import ChartJSComponent from '../../../dashboard/ChartJSComponent';
import { ChartType } from '@trlogic/ui-pack';
import moment from 'moment/moment';
import MessageUtil from '../../../../util/MessageUtil';
import JobService from '../../../../service/JobService';
import Icon from '../../../../icons/Icon';
import { ChartExportJob } from '../../../../domain/job/JobDomain';
import ChartUtil from '../../../../util/ChartUtil';
import LanguageUtil from '../../../../util/LanguageUtil';

class CaseDetailChartPanelComponent extends Component<Props> {
  public state: State = new State();

  private chartService: ChartService = ServiceContainer.getInstance().get(ServiceNames.CHART);
  private readonly jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);

  public render() {
    const { panel } = this.props;
    const { chartResponse } = this.state;
    return (
      <div
        className={`h-[416px] w-full flex flex-col bg-[#FFFFFF] border-[#E0E4E8] border-[1px] rounded-[10px] ${panel.gridType == 'even' ? 'col-span-2' : 'col-span-1'} min-h-[200px] overflow-y-scroll`}
      >
        <span className='flex flex-row h-[50px] w-full justify-between items-center px-5  border-b-[1px] border-[#E0E4E8] rounded-t-[10px] bg-[#F9FAFB]'>
          <div className={'text-primary'}>{panel.title}</div>
          <div
            onClick={this.exportCharPanel}
            className='cursor-pointer relative group border rounded border-[#E0E4E8] min-w-[28px] h-[28px] flex items-center justify-center bg-white hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7]'
          >
            <Icon icon={'export'} size={16} color={'#4F4F4F'} className={'hover:text-primary hover:cursor-pointer flex items-center justify-center'} />
          </div>
        </span>
        {chartResponse && (
          <ChartJSComponent
            chartType={chartResponse.type as ChartType}
            data={chartResponse?.result}
            chartName={chartResponse?.name}
            options={chartResponse?.attributes?.visualOptions}
            segmentItem={chartResponse?.attributes?.segmentItem}
            metrics={chartResponse?.attributes?.metricItem}
          />
        )}
      </div>
    );
  }

  public async componentDidMount() {
    const { panel, transactionData } = this.props;
    let transactionDataValue = transactionData?.variables[panel.filterWith.value];
    const chartResponse = await this.chartService.simulateChartForCase(panel.selectedChart, panel, transactionDataValue);
    chartResponse.result = ChartUtil.setColorPalette(chartResponse.attributes as ChartEditorOptions, chartResponse.result, chartResponse.type as ChartType);
    this.setState({ chartResponse });
  }

  private exportCharPanel = async () => {
    const { chartResponse } = this.state;
    try {
      const job: ChartExportJob = {
        type: 'CHART_EXPORT',
        timestamp: moment().valueOf(),
        status: 'PENDING',
        chartId: chartResponse?.id as string,
        data: chartResponse?.result as ChartJsDataModel,
        extension: 'csv',
        path: '',
      };
      await this.jobService.schedule(job);
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'common.label.export' }),
        detail: <div>{LanguageUtil.get({ id: 'messages.success.exportScheduled' })}</div>,
      });
    } catch (e) {
      console.error(e);
    }
  };
}

interface Props {
  panel: CaseChartPanel;
  transactionData: TransactionData | null;
}

class State {
  chartResponse: ChartResponse | null = null;
}

export default CaseDetailChartPanelComponent;
